
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    Textarea,
    Card,
    Modal,
    Button,
    message,
    Popconfirm,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    ExpandableText,
    Alert,
    Typography
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { ManageMARCRecordTable } from '../../Library/views/BackStage/ManageMARCRecord'
import { Trash2, Plus, Check, TriangleAlert, Info } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs"
import dayjs from 'dayjs';
import * as XLSX from 'xlsx-js-style';
import axios from 'axios';

const parseExcelBarcodes = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
            try {
                const wb = XLSX.read(e.target.result, { type: 'binary' })
                const ws = wb.Sheets[wb.SheetNames[0]]
                const rows = XLSX.utils.sheet_to_json(ws, { header: 1 })
                const barcodes = rows.slice(1)
                    .map(r => r[0])
                    .filter(v => v != null && v !== '')
                    .map(v => String(v).trim())
                resolve(barcodes)
            } catch (err) { reject(err) }
        }
        reader.onerror = reject
        reader.readAsBinaryString(file)
    })

const downloadBarcodeTemplate = () => {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet([['館藏條碼']])
    XLSX.utils.book_append_sheet(wb, ws, '館藏條碼')
    XLSX.writeFile(wb, '館藏條碼匯入模板.xlsx')
}

const ScrappedListForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.scrapped_list_management",
    propsReloadCount,
    withdrawnOptions = [],
    readOnly = false

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);

    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        let items_list_items_data = (values?.items_list_items_data || []).map((itemValue) => {
            return {
                ...itemValue,
                itemnumber: itemValue?.item_itemnumber
            }
        })
        let authorised_value = withdrawnOptions.find((element) => {
            return element?.id === values?.withdrawn_id
        })?.authorised_value
        let temp = {
            ...values,
            items_list_items_data,
            authorised_value
        }
        temp = setParamsFilter({ ...temp })

        onFormFinish({
            ...temp
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
        console.log({
            value, name, type
        })
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                    disabled={readOnly}

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                propsForm={form}
                                propsReloadCount={propsReloadCount}
                                withdrawnOptions={withdrawnOptions}
                                readOnly={readOnly}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    propsForm,
    field,
    keyPrefix = "cataloging.scrapped_list_management",
    propsReloadCount,
    withdrawnOptions = [],
    readOnly = false
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    const actionRef = useRef();
    const columns = [
        {
            title: "序號",
            dataIndex: 'key',
            key: 'index',
            sorter: false,
            width: 15,
            render: (text, record, index) => {
                return (`${text}`)
            }
        },
        {
            title: t(`Barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
            sorter: false
        },
        {
            title: t(`book_title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            sorter: false,
            render: (text, record, index) => {
                return (`${record?.bib_title || ""}${record?.bib_subtitle || ""}`)

            }
        },
        {
            title: t(`bib_author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            sorter: false,
        },
        {
            title: t(`bib_publisher`),
            dataIndex: 'bib_publisher',
            key: 'bib_publisher',
            sorter: false,
            width: 200,
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
            sorter: false,
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
            sorter: false,

        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
            sorter: false,

        },
        {
            title: t(`item_serial_issue_number`),
            dataIndex: 'item_serial_issue_number',
            key: 'item_serial_issue_number',
            sorter: false,

        },
        {
            title: t(`Call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
            sorter: false,

        },
        {
            title: t(`withdrawn_status`),
            dataIndex: 'item_withdraw_name',
            key: 'item_withdraw_name',
            sorter: false,

            render: (text, record, index) => {
                if (!!record?.item_withdrawn) {
                    return <>
                        <Badge color="pink" text={record?.item_withdraw_name} />
                    </>
                } else {
                    return <>
                        -
                    </>
                }
            }
        },

        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            sorter: false,
            render: (text, record, index) => {
                let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                let statusCount = 0
                tags.forEach((ele) => {
                    if (!!record?.[ele]) {
                        statusCount++
                    }
                })
                if (!!record?.issue_cancheckout) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                }
                else {
                    if (statusCount > 0) {
                        return (<>
                            不可借出
                            <p>
                                {record?.item_damaged_authorised_values && <Badge text={record?.item_damaged_authorised_values}>

                                </Badge>}
                            </p>
                            <p>
                                {record?.item_notforloan_authorised_values && <Badge text={record?.item_notforloan_authorised_values}>
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_restricted_authorised_values && <Badge text={record?.item_restricted_authorised_values}>
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_withdrawn_authorised_values && <Badge text={record?.item_withdrawn_authorised_values}>
                                </Badge>}
                            </p>
                        </>)
                    }
                    else {
                        return t(`CantCheckout`)
                    }
                }
            }
            // render: (text, record, index) => {
            //     if (!!record?.issue_cancheckout) {
            //         return <>
            //             <Badge color="green" text={t(`CanCheckout`)} />
            //         </>
            //     } else {
            //         return <>
            //             <Badge color="orange" text={t(`CantCheckout`)} />
            //         </>
            //     }
            // }
        },
        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
            sorter: false,

        },
        {
            title: t(`operation`),
            dataIndex: 'operation',
            key: 'operation',
            sorter: false,

            render: (text, record, index) => {
                return (<Button variant="ghost" size="icon"
                    onClick={() => {
                        let oldData = propsForm.getFieldValue("items_list_items_data")
                        let data = oldData.filter((ele, ind) => ind !== index)
                        propsForm.setFieldValue("items_list_items_data", data)
                        reload()
                    }}
                >
                    <Trash2 className="h-4 w-4" />
                </Button>)
            }
        },


    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.forEach((value) => {
                    select_temp.push(value?.item_itemnumber)
                    selectRow.push(value)
                })
            } else {
                changeRows.forEach((value) => {
                    const index = select_temp.indexOf(value?.item_itemnumber)
                    select_temp.splice(index, 1)
                    selectRow.splice(index, 1)
                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record?.item_itemnumber)
                selectRow.push(record)
            } else {
                select_temp = select_temp.filter((key) => key !== record?.item_itemnumber)
                selectRow = selectRow.filter((row) => row?.item_itemnumber !== record?.item_itemnumber)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        }
    }
    const batchDelete = () => {
        const oldData = propsForm.getFieldValue("items_list_items_data") || []
        const newData = oldData.filter(
            (ele) => !selectedRowKeys.includes(ele?.item_itemnumber)
        )
        propsForm.setFieldValue("items_list_items_data", newData)
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
        reload()
    }
    const reload = () => {
        actionRef.current.reloadAndRest()
    }
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        if (!!propsReloadCount) {
            reload()
        }
    }, [propsReloadCount])
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Card title={t('list_information')} >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Row>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'create_user_name']}
                                            fieldKey={[field?.fieldKey ?? '', 'create_user_name']}
                                            label={t('creator')}
                                            labelCol={24}
                                            wrapperCol={24}
                                            disabled={true}
                                        >
                                            <Input disabled={true} />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'create_time']}
                                            fieldKey={[field?.fieldKey ?? '', 'create_time']}
                                            label={t('creation_time')}
                                            labelCol={24}
                                            wrapperCol={24}
                                            disabled={true}
                                        >
                                            <Input disabled={true} />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                        <Row align="bottom">
                                            {propsForm.getFieldValue("list_number") ? <Col span={24} >
                                                <Form.Item
                                                    {...field}
                                                    name={[field?.name ?? '', 'list_number']}
                                                    fieldKey={[field?.fieldKey ?? '', 'list_number']}
                                                    label={"編號"}
                                                    labelCol={24}
                                                    wrapperCol={24}
                                                    disabled={true}

                                                >
                                                    <Input disabled={true} />
                                                </Form.Item>
                                            </Col>
                                                :
                                                <Col xxl={18} xl={18} lg={18} md={18} sm={12} xs={24} >
                                                    <Form.Item
                                                        {...field}
                                                        name={[field?.name ?? '', 'list_number_text']}
                                                        fieldKey={[field?.fieldKey ?? '', 'list_number_text']}
                                                        label={"編號"}
                                                        labelCol={24}
                                                        wrapperCol={24}
                                                        disabled={true}
                                                        rules={[{
                                                            required: true,
                                                            message: '請輸入'
                                                        }]}
                                                    >
                                                        <Input disabled={true} />
                                                    </Form.Item>
                                                </Col>}
                                            {!propsForm.getFieldValue("list_number") &&
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24} hidden={readOnly}>
                                                    <AddListNumberModal
                                                        onFormFinish={(val) => {
                                                            propsForm.setFieldValue("list_number_text", val?.list_number_text)
                                                            // propsForm.setFieldValue("list_number", val?.list_number_text)
                                                        }}
                                                    />
                                                </Col>}
                                        </Row>
                                    </Col>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                        <Form.List
                                            {...field}
                                            fieldKey={[field?.fieldKey ?? '', 'list_task_data']}
                                            name={[field?.name ?? '', 'list_task_data']}
                                        >
                                            {(fields, { add, remove }) => <Row gutter={[0, 0]}>
                                                <Col span={24}>
                                                    {fields.map((field, index) => {
                                                        return (
                                                            <Form.Item
                                                                {...field}
                                                                name={[field?.name ?? '', 'task_name']}
                                                                fieldKey={[field?.fieldKey ?? '', 'task_name']}
                                                                label={"名稱"}
                                                                labelCol={24}
                                                                wrapperCol={24}
                                                                disabled={readOnly}
                                                                rules={[{
                                                                    required: true,
                                                                    message: '請輸入'
                                                                }]}
                                                            >
                                                                <Input disabled={readOnly} />
                                                            </Form.Item>
                                                        )
                                                    })}
                                                </Col>
                                            </Row>}
                                        </Form.List>
                                    </Col>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'withdrawn_id']}
                                            fieldKey={[field?.fieldKey ?? '', 'withdrawn_id']}
                                            label={t('disposal_status')}
                                            labelCol={24}
                                            wrapperCol={24}
                                            disabled={readOnly}
                                        >
                                            <Select
                                                options={withdrawnOptions}
                                                disabled={readOnly}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'reason']}
                                            fieldKey={[field?.fieldKey ?? '', 'reason']}
                                            label={t('disposal_reason')}
                                            labelCol={24}
                                            wrapperCol={24}
                                            disabled={readOnly}
                                        >
                                            <Textarea disabled={readOnly} />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card title={t('collection_list')} >
                        <Row>
                            <Col span={24}>
                                <Form.List
                                    {...field}
                                    fieldKey={[field?.fieldKey ?? '', 'items_list_items_data']}
                                    name={[field?.name ?? '', 'items_list_items_data']}
                                >
                                    {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                                        {!readOnly && <Col span={24}>
                                            <Row justify="end" gutter={[8, 8]}>
                                                <Col>
                                                    <ExcelBatchDeleteModal propsForm={propsForm} reload={reload} />
                                                </Col>
                                                <Col>
                                                    <ExcelReplaceModal propsForm={propsForm} reload={reload} />
                                                </Col>
                                                <Col>
                                                    <AddItemModal
                                                        t={t}
                                                        defaultSelectkeys={propsForm.getFieldValue("items_list_items_data")?.map((val) => val?.item_itemnumber)}
                                                        defaultSelectInfos={propsForm.getFieldValue("items_list_items_data")}
                                                        // field={subscriptionField}
                                                        propsForm={propsForm}
                                                        reload={reload}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>}
                                        <Col span={24}>
                                            <ProTableOt
                                                reloadButton={false}
                                                manageColumnsButton={false}
                                                showSearch={false}
                                                readonly={true}
                                                actionRef={actionRef}
                                                showMode="page"  // page || infiniteScroll || card || cardPage,
                                                headerTitle={
                                                    <>

                                                    </>
                                                }
                                                columns={readOnly ? columns.filter(column => column.key !== 'operation') : columns}
                                                rowKey={'item_itemnumber'}
                                                toolBarRender={() => {
                                                    if (readOnly) return []
                                                    return [
                                                        selectedRowsInfo.length > 0 ? (
                                                            <Popconfirm
                                                                key="batchDelete"
                                                                title={`確認刪除已選取的 ${selectedRowsInfo.length} 筆館藏資料？`}
                                                                onConfirm={batchDelete}
                                                                okText="確定"
                                                                cancelText="取消"
                                                            >
                                                                <Button variant="destructive">
                                                                    批次刪除（{selectedRowsInfo.length}）
                                                                </Button>
                                                            </Popconfirm>
                                                        ) : null
                                                    ].filter(Boolean)
                                                }}
                                                // extra_columns={[]}
                                                // set_extra_columns={set_extra_columns}
                                                manage_columns={false}
                                                // request={async (params = {}, sort, filter) => {
                                                //     return {
                                                //         data: propsForm.getFieldValue('items_list_items_data') || [],
                                                //         total: (propsForm.getFieldValue('items_list_items_data') || []).length
                                                //     }
                                                // }}
                                                request={async (params = {}, sort, filter) => {
                                                    let newParams = {};
                                                    let order = setOrders(sort);
                                                    newParams = {
                                                        ...params,
                                                        ...newParams,
                                                        order,
                                                        size: params.pageSize,
                                                        cur_page: params.current,
                                                        custom_filter_value: params.keyword ?? "",
                                                    };
                                                    newParams = setParamsFilter({
                                                        ...newParams,
                                                    });
                                                    let startIndex = (newParams?.cur_page - 1) * newParams?.size
                                                    let endIndex = Math.min(startIndex + newParams?.size, (propsForm.getFieldValue('items_list_items_data') || []).length)
                                                    let currentData = (propsForm.getFieldValue('items_list_items_data') || []).slice(startIndex, endIndex)
                                                    currentData = currentData.map((value, index) => {
                                                        return {
                                                            ...value,
                                                            key: (newParams?.cur_page - 1) * newParams?.size + index + 1
                                                        }
                                                    })

                                                    return {
                                                        data: currentData,
                                                        total: (propsForm.getFieldValue('items_list_items_data') || []).length
                                                    }
                                                }}
                                                rowSelection={readOnly ? undefined : {
                                                    type: 'checkbox',
                                                    selectedRowKeys,
                                                    selectedRowsInfo,
                                                    setSelectedRowKeys,
                                                    setSelectedRowsInfo,
                                                    ...rowSelection,
                                                }}
                                                propsPatch={false}
                                                propsDelete={false}
                                                propsPost={false}
                                                propsWidth={2400}
                                                scroll={{
                                                    x: "100%",
                                                }}
                                                extraActionRenderShow={false}
                                            />
                                        </Col>
                                    </Row>}
                                </Form.List>
                            </Col>
                        </Row>
                    </Card>
                </Col>

            </Row>
        </>
    );
};
const ExcelBatchDeleteModal = ({ propsForm, reload }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [parsedBarcodes, setParsedBarcodes] = useState([])
    const [matchCount, setMatchCount] = useState(0)
    const fileInputRef = useRef(null)

    const handleFileSelect = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        try {
            const barcodes = await parseExcelBarcodes(file)
            const currentItems = propsForm.getFieldValue("items_list_items_data") || []
            const matches = currentItems.filter(item => barcodes.includes(item?.item_barcode)).length
            setParsedBarcodes(barcodes)
            setMatchCount(matches)
        } catch {
            message.error('Excel 解析失敗，請確認檔案格式')
        }
        e.target.value = ''
    }

    const handleConfirm = () => {
        const currentItems = propsForm.getFieldValue("items_list_items_data") || []
        const newItems = currentItems.filter(item => !parsedBarcodes.includes(item?.item_barcode))
        propsForm.setFieldValue("items_list_items_data", newItems)
        message.success(`已刪除 ${matchCount} 筆館藏資料`)
        setParsedBarcodes([])
        setMatchCount(0)
        setIsOpen(false)
        reload()
    }

    const handleClose = () => {
        setParsedBarcodes([])
        setMatchCount(0)
        setIsOpen(false)
    }

    return (
        <>
            <Button onClick={() => setIsOpen(true)}>Excel 批次刪除</Button>
            <Modal
                title="Excel 批次刪除"
                open={isOpen}
                onCancel={handleClose}
                footer={null}
                width={480}
            >
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <Button onClick={downloadBarcodeTemplate}>下載模板</Button>
                    </Col>
                    <Col span={24}>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileSelect}
                            style={{ display: 'none' }}
                        />
                        <Button onClick={() => fileInputRef.current?.click()}>選擇 Excel 檔案</Button>
                    </Col>
                    {parsedBarcodes.length > 0 && (
                        <Col span={24}>
                            <p>已讀取 {parsedBarcodes.length} 筆條碼，其中 <strong>{matchCount}</strong> 筆符合現有清單</p>
                        </Col>
                    )}
                    <Col span={24}>
                        <Popconfirm
                            title={`確認刪除符合的 ${matchCount} 筆館藏資料？`}
                            onConfirm={handleConfirm}
                            okText="確定"
                            cancelText="取消"
                            disabled={matchCount === 0}
                        >
                            <Button variant="destructive" disabled={matchCount === 0}>
                                確認批次刪除
                            </Button>
                        </Popconfirm>
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

const ExcelReplaceModal = ({ propsForm, reload }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [parsedBarcodes, setParsedBarcodes] = useState([])
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState({ current: 0, total: 0 })
    const fileInputRef = useRef(null)

    const handleFileSelect = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        try {
            const barcodes = await parseExcelBarcodes(file)
            setParsedBarcodes(barcodes)
        } catch {
            message.error('Excel 解析失敗，請確認檔案格式')
        }
        e.target.value = ''
    }

    const handleConfirm = async () => {
        setLoading(true)
        setProgress({ current: 0, total: parsedBarcodes.length })
        const results = []
        const notFound = []
        for (let i = 0; i < parsedBarcodes.length; i++) {
            setProgress({ current: i + 1, total: parsedBarcodes.length })
            try {
                const res = await axios.get('/koha/item', { params: { barcode: parsedBarcodes[i] } })
                const item = (res.data?.data || []).find(e => true)
                if (item) results.push(item)
                else notFound.push(parsedBarcodes[i])
            } catch {
                notFound.push(parsedBarcodes[i])
            }
        }
        propsForm.setFieldValue("items_list_items_data", results)
        setLoading(false)
        setIsOpen(false)
        setParsedBarcodes([])
        reload()
        if (notFound.length > 0) {
            message.warning(`已匯入 ${results.length} 筆，${notFound.length} 筆條碼未找到`)
        } else {
            message.success(`已整批替換，共匯入 ${results.length} 筆館藏資料`)
        }
    }

    const handleClose = () => {
        if (loading) return
        setParsedBarcodes([])
        setIsOpen(false)
    }

    return (
        <>
            <Button onClick={() => setIsOpen(true)}>Excel 整批替換</Button>
            <Modal
                title="Excel 整批替換"
                open={isOpen}
                onCancel={handleClose}
                footer={null}
                maskClosable={false}
                width={480}
            >
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <Button onClick={downloadBarcodeTemplate} disabled={loading}>下載模板</Button>
                    </Col>
                    <Col span={24}>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileSelect}
                            style={{ display: 'none' }}
                        />
                        <Button onClick={() => fileInputRef.current?.click()} disabled={loading}>
                            選擇 Excel 檔案
                        </Button>
                    </Col>
                    {parsedBarcodes.length > 0 && (
                        <Col span={24}>
                            <p>已讀取 <strong>{parsedBarcodes.length}</strong> 筆條碼，確認後將取代現有清單</p>
                        </Col>
                    )}
                    {loading && (
                        <Col span={24}>
                            <p>處理中 {progress.current} / {progress.total}</p>
                        </Col>
                    )}
                    <Col span={24}>
                        <Popconfirm
                            title="確認以 Excel 內容整批替換現有清單？此操作無法復原。"
                            onConfirm={handleConfirm}
                            okText="確定"
                            cancelText="取消"
                            disabled={parsedBarcodes.length === 0 || loading}
                        >
                            <Button disabled={parsedBarcodes.length === 0 || loading}>
                                確認整批替換
                            </Button>
                        </Popconfirm>
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

const AddListNumberModal = ({
    field,
    propsForm,
    propsOpen = null,
    openButtonText = "設定編號",
    defaultSelectkeys = [],
    defaultSelectInfos = [],
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    onFormFinish = () => { },
    t,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [listNumberValue, setListNumberValue] = useState({
        library: null,
        year: null
    })
    const [form] = Form.useForm();

    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        form.submit()
    };
    const onValuesChange = () => {

    }
    const onFinish = (values) => {
        let temp = {
            ...values,
            list_number_text: values?.year + values?.library
        }

        onFormFinish({
            ...temp
        });
        closeModal()
    };
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    useEffect(() => {
        libraryController.getData({})
        form.setFieldValue("year", dayjs().format("YYYY"))
    }, [])
    return (
        <div>
            <Button
                block={true}
                onClick={showModal}
            >
                設定編號
            </Button>
            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={closeModal}
                confirmLoading={loading}
                maskClosable={false}
                width={600}
                contentStyle={{
                    padding: 16,
                }}
                okText={'確定'}
                cancelText={"取消"}
            >
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'year']}
                                fieldKey={[field?.fieldKey ?? '', 'year']}
                                label={"年份"}
                                labelCol={24}
                                wrapperCol={24}
                                rules={[{
                                    required: true,
                                    message: '請輸入'
                                }]}
                            >
                                <Input type="number" min="1900" max="2100" step="1" pattern="\d{4}" />

                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'library']}
                                fieldKey={[field?.fieldKey ?? '', 'library']}
                                label={"分館"}
                                labelCol={24}
                                wrapperCol={24}
                                rules={[{
                                    required: true,
                                    message: '請選擇'
                                }]}
                            >
                                <Select
                                    defaultValue={listNumberValue?.library}
                                    value={listNumberValue?.library}
                                    options={libraryController?.ResponseData?.map((option) => {
                                        return {
                                            label: option?.branchname,
                                            value: option?.branchcode,
                                        }
                                    })}
                                >

                                </Select>
                            </Form.Item>
                        </Col>

                    </Row>

                </Form >

            </Modal>
        </div>
    );
}
const AddItemModal = ({
    reload = () => { },
    field,
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "詳細資訊",
    defaultSelectkeys = [],
    defaultSelectInfos = [],
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    t,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [addScanloading, setAddScanLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null)
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        reload()
    };

    const handleOk = () => {
        setLoading(true);
        propsHandleOk(selectRow)
        setScannedItem([])
        closeModal();

    };

    const [newItem, setNewItem] = useState({
        item_barcode: null,
        status: "info",
        bib_title: null,
        bib_subtitle: null,
        bib_author: null,
        item_branchname_holding: null,
        item_itemcallnumber: null,
        item_withdrawn: null,
        issue_cancheckout: null

    })

    // Add these new state variables and functions at the top of your component
    const [scannedItem, setScannedItem] = useState([])

    // Handle barcode scanning
    const handleBarcodeScanned = () => {
        let items_list_items_data = propsForm.getFieldValue('items_list_items_data') || []
        if (!newItem?.item_barcode) return
        if (items_list_items_data.some((ele) => ele?.item_barcode === newItem?.item_barcode)) {
            message.error("已存在報廢清單中")
            return
        }
        setAddScanLoading(true)
        ItemController.getData({
            barcode: newItem?.item_barcode
        })
            .then((response) => {
                let data = response?.data || []
                let firstData = data?.find((ele) => true)
                setScannedItem((pre) => {
                    let oldScanned = [...pre]
                    let newScanned = [...oldScanned]
                    let selectValue = propsForm.getFieldValue('items_list_items_data') || []
                    if (!!firstData) {
                        newScanned = [{ ...firstData, status: "success" }, ...newScanned]
                        selectValue.push({ ...firstData })
                    }
                    else {
                        newScanned = [{ ...newItem, status: "error" }, ...newScanned]
                    }
                    propsForm.setFieldValue("items_list_items_data", selectValue)
                    return newScanned
                })
            })
            .finally(() => {
                setAddScanLoading(false)
            })

        // Clear the barcode input for next scan
        setNewItem({ ...newItem, item_barcode: "" })

        // Focus the input field again for the next scan
        setTimeout(() => {
            const barcodeInput = document.getElementById("barcode")
            if (barcodeInput) {
                ; (barcodeInput).focus()
            }
        }, 100)
    }
    const submitScanned = () => {
        let item_barcode_arr = scannedItem?.map((val) => val?.item_barcode)
        item_barcode_arr.forEach((item_barcode) => {
            ItemController.getData({
                barcode: item_barcode
            })
                .then((response) => {
                    let data = response?.data || []
                    let firstData = data?.find((ele) => true)
                    setScannedItem((pre) => {
                        let oldScanned = [...pre]
                        let newScanned = oldScanned.map((value) => {
                            if (item_barcode === value?.item_barcode) {
                                if (!!firstData) {
                                    let selectValue = propsForm.getFieldValue('items_list_items_data') || []
                                    selectValue.push({ ...firstData })
                                    propsForm.setFieldValue("items_list_items_data", selectValue)

                                    return {
                                        ...firstData,
                                        status: "success"
                                    }
                                }
                                else {
                                    return {
                                        ...value,
                                        status: "error"

                                    }
                                }

                            }
                            else {
                                return {
                                    ...value,
                                }
                            }
                        })
                        return newScanned
                    })
                })
                .finally(() => {
                })
        })

    }

    const ItemController = useCRUDController({
        apiRoute: "/koha/item",
    })

    return (
        <div>
            <Button
                onClick={showModal}
            >
                {t('add_detail')}
            </Button>
            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                // onCancel={handleCancel}
                confirmLoading={false}
                maskClosable={false}
                width={1000}
                contentStyle={{
                    padding: 16,
                }}
                okText={'關閉'}
            >
                <Row>
                    <Col span={24}>
                        <Tabs defaultValue="manual">
                            <TabsList className="grid w-full grid-cols-2">
                                <TabsTrigger value="manual">{t('manual_input')}</TabsTrigger>
                                <TabsTrigger value="search">{t('select_from_existing_collections')}</TabsTrigger>
                            </TabsList>
                            <TabsContent value="manual" className="space-y-4">
                                <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
                                    <p className="text-amber-800 flex items-center gap-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="w-5 h-5"
                                        >
                                            <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
                                            <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
                                            <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
                                            <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
                                            <path d="M8 7v10"></path>
                                            <path d="M12 7v10"></path>
                                            <path d="M17 7v10"></path>
                                        </svg>
                                        {t('barcode_scan_instruction')}
                                    </p>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex gap-2 items-end">
                                        <div className="flex-1">
                                            <label htmlFor="barcode" className="text-sm font-medium block mb-2">
                                                {t('Barcode')}
                                            </label>
                                            <Input
                                                id="barcode"
                                                name="barcode"
                                                value={newItem?.item_barcode || ""}
                                                onChange={(e) => setNewItem({ ...newItem, item_barcode: e.target.value, status: "info" })}
                                                placeholder={t('scan_or_enter_barcode')}
                                                autoFocus
                                                className="font-mono text-base"
                                                onKeyDown={(e) => {
                                                    // Auto submit when Enter key is pressed (most barcode scanners send Enter)
                                                    if (e.key === "Enter" && newItem?.item_barcode) {
                                                        e.preventDefault()
                                                        handleBarcodeScanned()
                                                    }
                                                }}
                                            />
                                        </div>
                                        <Button
                                            loading={addScanloading}
                                            onClick={handleBarcodeScanned}
                                            disabled={!newItem?.item_barcode}
                                        >
                                            {t('add')}
                                        </Button>
                                        {/* <Button
                                            type="default"
                                            onClick={() => {
                                                submitScanned()
                                            }}
                                            disabled={!scannedItem.length}>
                                            {t('confirm_scan')}
                                        </Button> */}
                                    </div>
                                    <Row>
                                        <Col span={24}>
                                            <Row gutter={[8, 8]}>
                                                {
                                                    scannedItem?.map((value) => {
                                                        let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                                                        let statusCount = 0
                                                        tags.forEach((ele) => {
                                                            if (!!value?.[ele]) {
                                                                statusCount++
                                                            }
                                                        })
                                                        return <Col span={24}>
                                                            <ScanItem
                                                                t={t}
                                                                status={value?.status}
                                                                description={<Row>
                                                                    <Col span={24}>
                                                                        <Row justify="space-between">
                                                                            <Col>
                                                                                {t(`Barcode`)}: {value?.item_barcode}
                                                                            </Col>
                                                                            <Col>
                                                                                {
                                                                                    value?.issue_cancheckout > 0 && value?.issue_cancheckout !== null &&
                                                                                    <Badge color="green" text={t(`CanCheckout`)} />
                                                                                }
                                                                                {
                                                                                    !value?.issue_cancheckout && value?.issue_cancheckout !== null && statusCount > 0 ?
                                                                                        (!value?.issue_cancheckout && <>
                                                                                            不可借出
                                                                                            <p>
                                                                                                {value?.item_damaged_authorised_values && <Badge
                                                                                                    color="orange"
                                                                                                    text={value?.item_damaged_authorised_values} >
                                                                                                </Badge>}
                                                                                            </p>
                                                                                            <p>
                                                                                                {value?.item_notforloan_authorised_values && <Badge
                                                                                                    color="orange"
                                                                                                    text={value?.item_notforloan_authorised_values}
                                                                                                >
                                                                                                </Badge>}
                                                                                            </p>
                                                                                            <p>
                                                                                                {value?.item_restricted_authorised_values && <Badge
                                                                                                    color="orange"
                                                                                                    text={value?.item_restricted_authorised_values}
                                                                                                >
                                                                                                </Badge>}
                                                                                            </p>
                                                                                            <p>
                                                                                                {value?.item_withdrawn_authorised_values && <Badge
                                                                                                    color="orange"
                                                                                                    text={value?.item_withdrawn_authorised_values}
                                                                                                >
                                                                                                </Badge>}
                                                                                            </p>

                                                                                        </>)
                                                                                        :
                                                                                        (!value?.issue_cancheckout && value?.issue_cancheckout !== null && <Badge color="orange" text={t(`CantCheckout`)} />)
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col span={24}>
                                                                        {value?.bib_title || ""}{value?.bib_subtitle || ""}
                                                                    </Col>
                                                                </Row>}
                                                            />
                                                        </Col>
                                                    })
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </TabsContent>
                            <TabsContent value="search" className="space-y-4">
                                <Row>
                                    <Col span={24}>
                                        <ItemTable
                                            defaultSelectkeys={defaultSelectkeys}
                                            defaultSelectInfos={defaultSelectInfos}
                                            onSelectChange={(value) => {
                                                if (!!propsForm) {
                                                    propsForm.setFieldValue("items_list_items_data", value)
                                                }
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </TabsContent>
                        </Tabs>
                    </Col>
                </Row>
            </Modal>

        </div>
    );
}
const ItemTable = ({
    rowKey = "item_itemnumber",
    keyPrefix = "cataloging.scrapped_list_management",
    showAllColumns = true,
    propsShowColumns,
    propslist_id,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
    });
    const columns = [
        {
            title: t(`Barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`book_title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}

                    maxLines={2}>
                </ExpandableText>)

            }
        },
        {
            title: t(`bib_author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
            sorter: false,

        },
        {
            title: t(`bib_publisher`),
            dataIndex: 'bib_publisher',
            key: 'bib_publisher',
            sorter: false,
            width: 200,
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`Call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`withdrawn_status`),
            dataIndex: 'item_withdraw_name',
            key: 'item_withdraw_name',
            render: (text, record, index) => {
                if (!!record?.item_withdraw_name) {
                    return <>
                        <Badge color="pink" text={record?.item_withdraw_name} />
                    </>
                } else {
                    return <>
                        -
                    </>
                }
            }
        },

        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                let statusCount = 0
                tags.forEach((ele) => {
                    if (!!record?.[ele]) {
                        statusCount++
                    }
                })
                if (!!record?.issue_cancheckout) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                }
                else {
                    if (statusCount > 0) {
                        return (<>
                            不可借出
                            <p>
                                {record?.item_damaged_authorised_values && <Badge
                                    text={record?.item_damaged_authorised_values} >
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_notforloan_authorised_values && <Badge
                                    text={record?.item_notforloan_authorised_values}
                                >
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_restricted_authorised_values && <Badge
                                    text={record?.item_restricted_authorised_values}
                                >
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_withdrawn_authorised_values && <Badge
                                    text={record?.item_withdrawn_authorised_values}
                                >
                                </Badge>}
                            </p>

                        </>)
                    }
                    else {
                        return t(`CantCheckout`)
                    }

                }
            }
        },



        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        }

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const [search, setSearch] = useState({
        item_dateaccessioned_start: dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
        item_dateaccessioned_end: dayjs().format('YYYY-MM-DD'),
    })
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const onFinish = ({ axiosMode, status, values }) => {

    };
    const onBefore = ({ axiosMode, status, values }) => {

    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const ItemController = useCRUDController({
        apiRoute: "/koha/item",
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {

        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    useEffect(() => {
        actionRef.current.onTableSearch()
    }, [search])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                    ...search
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        {t(`Date accessioned`)}:
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Input
                                        type="date"
                                        // granularity={"day"}
                                        // placeholder={t(`.time_start`)}
                                        format={"YYYY-MM-DD"}
                                        value={search?.item_dateaccessioned_start ? search?.item_dateaccessioned_start : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.item_dateaccessioned_end, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        item_dateaccessioned_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        item_dateaccessioned_start: pre?.item_dateaccessioned_end,
                                                        item_dateaccessioned_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Input
                                        type="date"
                                        placeholder={t(`.time_end`)}
                                        format={"YYYY-MM-DD"}
                                        value={search?.item_dateaccessioned_end ? search?.item_dateaccessioned_end : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.item_dateaccessioned_start)) {
                                                    return {
                                                        ...pre,
                                                        item_dateaccessioned_start: e.target.value,
                                                        item_dateaccessioned_end: pre?.item_dateaccessioned_start,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        item_dateaccessioned_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(search?.item_dateaccessioned_start || search?.item_dateaccessioned_end) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setSearch((pre) => {
                                                    return {
                                                        item_dateaccessioned_start: undefined,
                                                        item_dateaccessioned_end: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams,...search }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        ...newTableSearchParams,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return ItemController.getData(newParams);
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
            // extraActionRender={(record) => {
            // }}
            />
        </Col>
    </Row>)

}
const Badge = ({
    color = "blue",
    text = ""
}) => {
    // red, orange, amber, yellow, lime, green, emerald, teal, cyan, sky, blue,
    // indigo, violet, purple, fuchsia, pink, rose, slate, gray, zinc, neutral, stone

    return (<span
        className={`px-2 py-1 rounded-full text-xs  bg-${color}-100 text-${color}-800 whitespace-nowrap`}
    >
        {text}
    </span>)
}
const ScanItem = ({
    status = "info", //info success error 
    description = "",
    t
}) => {
    return (<Row>
        {status === "info" &&
            <Col span={24}>
                <Alert
                    type={"info"}
                    message={t('scanned_collection_barcode')}
                    description={description}
                    icon={<Info className="h-5 w-5" />}
                    showIcon={true}
                />
            </Col>}
        {status === "success" &&
            <Col span={24}>
                <Alert
                    type={"success"}
                    message={t('successfully_added_collection_item')}
                    description={description}
                    icon={<Check className="h-5 w-5" />}
                    showIcon={true}
                />
            </Col>}
        {status === "error" &&
            <Col span={24}>
                <Alert
                    type={"error"}
                    message={t('collection_item_not_found')}
                    description={description}
                    icon={<TriangleAlert className="h-5 w-5" />}
                    showIcon={true}
                />
            </Col>}
    </Row>)
}

export default ScrappedListForm;
